import { formatNumberValue } from "utilities/numbers";

export const formatCurrencyValue = (value: number | string, currency: string) =>
  `${formatNumberValue(value, "", 2)} ${currency}`;

export const segmentConditions = [
  { id: "is_equal", label: "is_equal" },

  {
    id: "is_greater",
    label: "is_greater_than",
  },
  {
    id: "is_greater_or_equal",
    label: "is_greater_or_equal",
  },
  { id: "is_less", label: "is_less_than" },
  {
    id: "is_less_or_equal",
    label: "is_less_or_equal",
  },
  {
    id: "is_number_between",
    label: "is_between",
  },
];

export const segmentAchievementGoal = [
  { id: "completed_periods", label: "completedPeriods" },

  {
    id: "current_progress",
    label: "currentProgress",
  },
];
